import type { ServerColDef } from '@cmg/data-grid';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';
import { EmployeeKeyCellRenderer } from './EmployeeKeyCellRenderer';

const employeeKeyColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'employeeKey',
  headerName: 'Employee Key',
  minWidth: 200,
  cellRenderer: EmployeeKeyCellRenderer,
  pinned: 'left',
};

export default employeeKeyColDef;
